import _extends from '@babel/runtime/helpers/extends';
import { forwardRef, Icon } from '@chakra-ui/react';
import * as React from 'react';
var Svg = forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2
    },
    width: "1em",
    height: "1em"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.5 24 13-12-13-12v24Z",
    fill: "currentColor"
  }));
});
var ArrowRightDrop = forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    as: Svg
  }, props, {
    ref: ref
  }));
});
export { ArrowRightDrop };